import { Component, OnInit } from '@angular/core';
import { Answer } from '../../../../applicant-service/service-models/Answer';
import { Choice } from '../../../../job-service/service-models/Choice';
import { MultipleChoiceAutoScoreQuestion } from '../../../../job-service/service-models/MultipleChoiceAutoScoreQuestion';
import { QuestionComponent } from '../question-component';

@Component({
  selector: 'app-multiple-choice-auto-score',
  templateUrl: './multiple-choice-auto-score.component.html',
  styleUrls: ['./multiple-choice-auto-score.component.scss']
})
export class MultipleChoiceAutoScoreComponent extends QuestionComponent<MultipleChoiceAutoScoreQuestion> implements OnInit {
  ngOnInit() {
    this.question = this.question || new MultipleChoiceAutoScoreQuestion();

    if (this.question.answers === undefined) {
      this.question.answers = new Array<Answer>();
      this.question.answers.push(new Answer());
    }
  }

  isChecked(choice: Choice) {
    return this.question.answers.some(x => x.choiceId === choice.id);
  }

  onChoiceChange(choice: Choice) {
    this.question.answers[0].choiceId = choice.id;
    this.question.answers[0].questionId = this.question.id;
    this.question.answers[0].questionVersion = this.question.version;
    this.question.answers[0].value = choice.value;
    this.questionAnswered();
  }
}
